import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App'
import Home from './components/home';


ReactDOM.render( <App />, document.getElementById("root"))


// WEBPACK FOOTER //
// ./src/index.js